import { RxStompConfig } from '@stomp/rx-stomp';
import { RxStompService } from './rx-stomp.service';

export function rxStompServiceFactory() {
  const rxStomp = new RxStompService();
  rxStomp.configure(new RxStompConfig);
  rxStomp.activate();
  return rxStomp;
}